import React from "react";
import { NotFound as PageNotFound } from "@swegon/sds-core";

const NotFound = () => {
    return <PageNotFound />;
};
export default NotFound;
